import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import Charts from 'chart.js';

@Component({

})
export default class Doughnut extends Vue{
  @Prop({required: true}) readonly value!: Choice[];
  @Watch('value', {deep: true})
  onValueChange(value: Choice[], oldValue: Choice[]){
    const datasets = this.chart.data.datasets;
    if (!datasets || !datasets[0]){
      return;
    }
    this.chart.data.labels = this.value.map(choice => choice.title);
    datasets[0].data = value.map(choice => choice.value);
    datasets[0].backgroundColor = value.map(choice => choice.color);
    if (value.length != oldValue.length){
      // this.chart
    }
    this.chart.update();
  }
  get canvas() {
    return this.$refs.canvas as HTMLCanvasElement;
    // return this.$el as HTMLCanvasElement;
  }
  render(createElement: Vue.CreateElement): Vue.VNode{
    return createElement('div', {
      style: {
        position: 'relative',
      }
    },[
      createElement('canvas', {ref: 'canvas'}),
    ]);
  }
  chart!: Charts;
  mounted () {
    this.chart = new Charts.Chart(this.canvas, {
      type: 'doughnut',
      data: {
        labels: this.value.map(choice => choice.title),
        datasets: [
          {
            data: this.value.map(choice => choice.value),
            backgroundColor: this.value.map(choice => choice.color),
          }
        ]
      },
      options: {
        responsive: true,
        aspectRatio: 1,
        // scale: {
        //   display: false,
        // },
        legend: {
          display: false,
        },
        // tooltips: {
        //   enabled: false,
        // },
        title: {
          display: true,
        },
        rotation: -Math.PI,
        // startAngle: -Math.PI*1.5,
        // circumference: Math.PI,
      },
    });
  }
}
